// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__3jqs1","banner":"Banner_banner__pDz1a","bannerImage":"Banner_bannerImage__k-XV3"};